<template>
    <div
        class="tw-flex tw-w-max tw-items-center tw-rounded-4xl tw-px-5 tw-py-3 tw-font-light tw-text-white max-md:tw-text-sm"
        :class="`tw-bg-${color}`">
        <ArrowLeftIcon />
        <span class="tw-mx-2 tw-font-medium">{{ text }}</span>
        <ArrowRightIcon />
    </div>
</template>

<script setup lang="ts">
    import ArrowLeftIcon from '@/components/icons/arrow-left.vue';
    import ArrowRightIcon from '@/components/icons/arrow-right.vue';

    defineProps<{
        color: string;
        text: string;
    }>();
</script>

<style scoped></style>
